"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInitialActiveTabId = void 0;
var _react = require("react");
var findInitialActiveTabId = exports.findInitialActiveTabId = function findInitialActiveTabId(children) {
  var _children$, _children$$props;
  if (_react.Children.count(children) === 1) {
    var _children$props;
    var singleChildId = children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.id;
    return singleChildId;
  }
  var initialActiveTabIndex = _react.Children.toArray(children).findIndex(function (child) {
    return child.props.initialActive;
  });
  if (initialActiveTabIndex >= 0) {
    var _children$initialActi, _children$initialActi2;
    var firstChildWithInitialActiveTabPropId = (_children$initialActi = children[initialActiveTabIndex]) === null || _children$initialActi === void 0 ? void 0 : (_children$initialActi2 = _children$initialActi.props) === null || _children$initialActi2 === void 0 ? void 0 : _children$initialActi2.id;
    return firstChildWithInitialActiveTabPropId;
  }
  var firstChildIdOfChildren = (_children$ = children[0]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : _children$$props.id;
  return firstChildIdOfChildren;
};